export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="shrink-0 w-full lg:w-[420px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20cinema%20interior%20with%20warm%20amber%20lighting%2C%20luxurious%20velvet%20seats%2C%20large%20movie%20screen%20with%20soft%20glow%2C%20art%20deco%20theater%20design%2C%20rich%20dark%20and%20golden%20tones%2C%20premium%20entertainment%20atmosphere%2C%20no%20text%20no%20people&width=800&height=600&seq=about-mitao-2026&orientation=landscape"
              alt="密桃视频 - 品牌介绍"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-information-line text-primary-600 text-lg"></i>
              </div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950">关于密桃视频</h2>
            </div>
            <p className="text-sm text-foreground-500 mb-5 pl-11">了解我们的故事与初心</p>
            <div className="pl-0 lg:pl-11 space-y-4">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                密桃视频成立于2024年，致力于为广大影迷打造一站式的免费高清观影平台。我们汇聚91视频、91视频网站、久久视频等全网热门资源，覆盖电影、电视剧、动漫、纪录片等全品类内容，每日实时更新最新上映和热播影片。91在线视频播放采用先进的流媒体传输技术，确保高清画质与流畅播放不缓冲，让每一位用户都能享受沉浸式观影体验。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                平台内容团队每日精选优质影片，从热门院线大片到小众文艺佳作，从经典老片修复到最新海外剧集，为不同口味的观众提供丰富的选择。我们相信，好的影片值得被更多人看到，好的观影体验不应该有门槛。
              </p>
              <div className="flex flex-wrap gap-4 pt-2">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center">
                    <i className="ri-user-heart-line text-primary-500 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-foreground-900 whitespace-nowrap">500万+</div>
                    <div className="text-xs text-foreground-500 whitespace-nowrap">活跃用户</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-xl bg-accent-50 flex items-center justify-center">
                    <i className="ri-video-line text-accent-500 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-foreground-900 whitespace-nowrap">20000+</div>
                    <div className="text-xs text-foreground-500 whitespace-nowrap">影片资源</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-xl bg-secondary-50 flex items-center justify-center">
                    <i className="ri-shield-star-line text-secondary-500 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-foreground-900 whitespace-nowrap">99.9%</div>
                    <div className="text-xs text-foreground-500 whitespace-nowrap">播放成功率</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}